export type BoundedContext = typeof BOUNDED_CONTEXTS[number]

export const BOUNDED_CONTEXTS = [
  'destination/modules/',
  'control/modules/',
  'shared/modules/'
] as const // is the target set of bounded contexts

export const getBoundedContextOfComponent = (componentName: string): BoundedContext | undefined => {
  const foundContext = BOUNDED_CONTEXTS.find((boundedContext) =>
    componentName.startsWith(boundedContext)
  )
  return foundContext
}
